import React from "react";
import { Link } from "react-router-dom";
import { Users, Flame } from "lucide-react";
import { hubImageUrl } from "@/api";

export const short = (a) => (a ? `${a.slice(0, 6)}…${a.slice(-4)}` : "");

const TIER_STYLE = {
  Spark: "border-slate-500/40 text-slate-300", Ember: "border-orange-500/50 text-orange-300",
  Blaze: "border-amber-400/60 text-amber-300", Inferno: "border-red-500/60 text-red-300",
};

export function TierChip({ tier, multiplier, tid }) {
  return <span className={`chip ${TIER_STYLE[tier] || ""}`} data-testid={tid}><Flame size={12} /> {tier} · {multiplier}x</span>;
}

export function HubAvatar({ path, name, size = "w-14 h-14" }) {
  return path
    ? <img src={hubImageUrl(path)} alt={name} className={`${size} rounded-2xl object-cover border-2 border-[#0F101A]`} />
    : <div className={`${size} rounded-2xl bg-gradient-to-br from-orange-500 to-amber-400 flex items-center justify-center font-display font-black text-xl text-[#0F101A]`}>{name?.[0] || "?"}</div>;
}

export function HubCard({ h, onJoin, busy }) {
  return (
    <div className="card-tile p-0 overflow-hidden group transition-transform duration-300 hover:-translate-y-1" data-testid={`hub-card-${h.slug}`}>
      <Link to={`/hubs/${h.slug}`} className="block">
        <div className="h-24 bg-[#241B15] relative">
          {h.banner && <img src={hubImageUrl(h.banner)} alt="" className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity" />}
        </div>
        <div className="px-5 -mt-7 flex items-end gap-3 relative z-10">
          <HubAvatar path={h.avatar} name={h.name} />
          <TierChip tier={h.tier} multiplier={h.multiplier} tid={`hub-card-tier-${h.slug}`} />
        </div>
        <div className="px-5 pt-3">
          <h3 className="font-display text-lg font-bold truncate">{h.name}</h3>
          <p className="text-sm text-slate-400 line-clamp-2 min-h-[2.5rem]">{h.tagline}</p>
        </div>
      </Link>
      <div className="px-5 pb-5 pt-3 flex items-center gap-3 text-xs text-slate-400">
        <span className="flex items-center gap-1" data-testid={`hub-card-members-${h.slug}`}><Users size={13} /> {h.member_count}</span>
        <span className="truncate">by {short(h.creator)}</span>
        <div className="flex-1" />
        {onJoin && (h.joined
          ? <span className="chip border-emerald-500/40 text-emerald-300" data-testid={`hub-card-joined-${h.slug}`}>Joined</span>
          : <button onClick={() => onJoin(h)} disabled={busy} className="btn-tactile btn-flame text-xs px-3 py-1.5 whitespace-nowrap" data-testid={`hub-card-join-${h.slug}`}>Join Hub</button>)}
      </div>
    </div>
  );
}
